import { MasterCard } from '../../buy/services/payment-method.model';
import { Action } from './core/action';

export class PayByMasterpassAction implements Action {
  constructor(public card:MasterCard,
              public promocode: string,
              public onError: () => any) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/pay-by-masterpass.action.ts